import { rootApi } from '../../user/api';
// Define a service using a base URL and expected endpoints
const apiWithTag = rootApi.enhanceEndpoints({
  addTagTypes: ['Border'],
});
export const borderApi = apiWithTag.injectEndpoints({
  endpoints: (builder) => ({
    findAllBorders: builder.query({
      query: () => `borders/`,
      providesTags: ['Border'],
    }),
    findAllBordersWithLocation: builder.query({
      query: () => `borders/?location_master__isnull=False`,
      providesTags: ['Border'],
    }),
    findAllBordersOfCluster: builder.query({
      query: (id) => `borders/?cluster=${id}`,
      providesTags: ['Border'],
    }),
    findBorderById: builder.query({
      query: (id) => `borders/${id}/`,
      providesTags: (result, error, arg) => {
        return result ? [{ type: 'Border', id: result.id }] : ['Border'];
      },
    }),
    createBorder: builder.mutation({
      query: (border) => ({
        url: `borders/`,
        method: 'POST',
        body: border,
      }),
      invalidatesTags: ['Border'],
    }),
    updateBorder: builder.mutation({
      query: (border) => ({
        url: `borders/${border.id}/`,
        method: 'PATCH',
        body: border,
      }),
      invalidatesTags: ['Border'],
    }),
    updateLocation: builder.mutation({
      query: ({ id, payload }) => ({
        url: `borders/${id}/insertLocation/`,
        method: 'POST',
        body: payload,
      }),
      invalidatesTags: ['Border'],
    }),
    deleteBorder: builder.mutation({
      query: (border) => ({
        url: `borders/${border.id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Border'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useFindAllBordersQuery,
  useFindAllBordersWithLocationQuery,
  useFindBorderByIdQuery,
  useCreateBorderMutation,
  useUpdateBorderMutation,
  useDeleteBorderMutation,
} = borderApi;
